import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Flex } from "antd";
import { AppParagraph, AppText } from "../AppTypography";
import { AppButton } from "../AppButton";
import styles from "./styles.module.scss";

interface Props {
  disabled?: boolean;
  title?: string;
  onClick?: () => void;
  hint?: string;
}

export const BlockTitle: React.FC<Props> = ({ title, onClick, disabled, hint }) => {
  const { t } = useTranslation();

  return (
    <Flex vertical gap="xs" className={styles.container}>
      <div className={classNames(styles.wrapper)}>
        <AppParagraph size="md" weight="semibold" lineHeight="sm" className={styles.title}>
          {title}
        </AppParagraph>
        <AppButton
          onClick={onClick}
          type="text"
          className={styles["add-button"]}
          disabled={disabled}
        >
          + {t("common.add")}
        </AppButton>
      </div>
      {hint && (
        <AppText className={styles.hint}>
          <span>*</span> {hint}
        </AppText>
      )}
    </Flex>
  );
};
